import React, { memo, useCallback } from "react";

import { TextField, InputAdornment } from "@mui/material";

type IndexedRateComponentProps = {
  label: string;
  defaultValue: string;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
};

const IndexedRateComponent = memo((props: IndexedRateComponentProps) => {
  const { label, defaultValue, onBlur, onKeyDown } = props;

  // Limit user input between 0 and 100
  const handleInput = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    if (parseInt(e.target.value) > 100) {
      e.target.value = "100";
    } else if (!e.target.value || parseInt(e.target.value) < 0) {
      e.target.value = "";
    } else {
      e.target.value = parseInt(e.target.value).toString();
    }
  }, []);

  return (
    <TextField
      type="number"
      placeholder="0"
      fullWidth={true}
      label={label}
      variant="outlined"
      defaultValue={defaultValue}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      onInput={handleInput}
      InputProps={{
        endAdornment: <InputAdornment position="end">%</InputAdornment>,
      }}
    />
  );
});

export default IndexedRateComponent;
